// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-popover .popover {
  max-width: 500px !important;
  width: 500px !important;
  border-radius: 2em;
}

.custom-assessment-popover .popover {
  max-width: 420px !important;
  width: 420px !important;
  border-radius: 2em;
}

.legend-tooltip .tooltip-inner {
  max-width: 370px !important;
  width: 370px !important;
  background-color: white;
  border: 1px solid #8080801d;
  color: black;
}

.legend-tooltip .arrow::before {
  border-bottom-color: white !important;
}

.progress-transition {
  transition: none !important;
}

.bg-gray {
  background-color: gray;
}

.border-gray {
  border: gray;
}

.bg-withdrawn {
  background-color: #AA00FF;
}

.border-withdrawn {
  border: #AA00FF;
}`, "",{"version":3,"sources":["webpack://./../job/src/components/JobOverview/StepComponent.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;EACA,uBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,2BAAA;EACA,uBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,2BAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,YAAA;AACJ;;AAEA;EACI,qCAAA;AACJ;;AACA;EAKI,2BAAA;AAEJ;;AACA;EACI,sBAAA;AAEJ;;AACA;EACI,YAAA;AAEJ;;AACA;EACI,yBAAA;AAEJ;;AACA;EACI,eAAA;AAEJ","sourcesContent":[".custom-popover .popover {\n    max-width: 500px !important;\n    width: 500px !important;\n    border-radius: 2em;\n}\n\n.custom-assessment-popover .popover {\n    max-width: 420px !important;\n    width: 420px !important;\n    border-radius: 2em;\n}\n\n.legend-tooltip .tooltip-inner {\n    max-width: 370px !important;\n    width: 370px !important;\n    background-color: white;\n    border: 1px solid #8080801d;\n    color: black;\n}\n\n.legend-tooltip .arrow::before {\n    border-bottom-color: white !important;\n}\n.progress-transition {\n    -webkit-transition: none !important;\n    -moz-transition: none !important;\n    -o-transition: none !important;\n    -ms-transition: none !important;\n    transition: none !important;\n}\n\n.bg-gray {\n    background-color: gray;\n}\n\n.border-gray {\n    border: gray;\n}\n\n.bg-withdrawn {\n    background-color: #AA00FF;\n}\n\n.border-withdrawn {\n    border: #AA00FF;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
